import { Injectable } from '@angular/core';
import { EnvService } from '../env-service/env-service';
import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';

@Injectable({ providedIn: 'root' })
export class PushService {
  initialized = false;

  constructor(private envService: EnvService, private oneSignal: OneSignal) {}

  init() {
    if (this.envService.isAPP()) {
      this.initApp();
    } else {
      this.initPWA();
    }
  }

  /**
   * inizializza il provider di notifiche push per la app
   */
  private initApp() {
    try {
      // chiavi per AppDocenti
      this.oneSignal.startInit(
        this.envService.ONESIGNAL_ID,
        this.envService.GOOGLE_PROJECT_ID
      );

      // this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);

      this.oneSignal.handleNotificationReceived().subscribe(() => {
        // do something when notification is received
      });

      this.oneSignal.handleNotificationOpened().subscribe(() => {
        // do something when a notification is opened
      });

      this.oneSignal.endInit();

      this.initialized = true;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * inizializza il provider di notifiche push per la PWA
   */
  private initPWA() {
    // TODO
    console.log('notitiche web push non ancora supportate');
  }

  tag(key: string, value: string) {
    if (this.initialized) {
      this.oneSignal.sendTag(key, value);
    }
  }

  tags(json: any) {
    if (this.initialized) {
      this.oneSignal.sendTags(json);
    }
  }
}
